<template>
<div class="chapter">
<div class="inner_page">
<section class="couverture" epub:type="cover"><a id="cover"><img alt="Cover picture" class="img" role="doc-cover" src="Images/cover.jpg"/></a>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?7762fc72